import { createFileRoute, useParams } from '@tanstack/react-router';

import { DEFAULT_INDICATORS } from '@york/shared/schemas';

import { useClassProgress, useClassProgressSettings } from '@/api/me/class-progress.ts';
import { EmptyState } from '@/components/ui.tsx';
import { useAuth } from '@/store/auth.ts';
import { ClassProgressView } from '@/views/courses/detail/class-progress-view.tsx';

// 教师班级进度仪表板（动态指标列 + 仅 INSTRUCTOR 的
// 设置抽屉）。深链接到此的学生看到空状态——该 tab
// 对其导航隐藏。
export const Route = createFileRoute('/_learner/courses_/$id/class-progress/')({
  component: ClassProgressTab,
});

function ClassProgressTab() {
  const { id } = useParams({ from: '/_learner/courses_/$id/class-progress/' });
  const user = useAuth((s) => s.user);
  const isTeacher = user?.role === 'TEACHER' || user?.role === 'ADMIN';

  const dataQ = useClassProgress(id);
  const settingsQ = useClassProgressSettings(id);

  if (!user) return null;
  if (!isTeacher) {
    return <EmptyState>Class progress is only available to teachers.</EmptyState>;
  }
  if (dataQ.isPending || settingsQ.isPending) {
    return <ClassProgressSkeleton />;
  }
  if (dataQ.isError || !dataQ.data) {
    return <EmptyState>Could not load class progress for this course.</EmptyState>;
  }

  const settings = settingsQ.data?.indicators ?? DEFAULT_INDICATORS;

  return <ClassProgressView courseId={id} data={dataQ.data} settings={settings} canEdit={true} />;
}

function ClassProgressSkeleton() {
  return (
    <div className="space-y-3" aria-hidden>
      <div className="flex justify-end">
        <div className="h-8 w-20 animate-pulse rounded-md bg-neutral-100" />
      </div>
      <div className="h-64 w-full animate-pulse rounded-lg bg-neutral-100" />
    </div>
  );
}
